import React from 'react';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import GenericButton from '../GenericButton/GenericButton';

const AddButton: React.FC<{
	label: string;
	onClick: () => void;
	size?: 'sm' | 'md' | 'lg';
	invert?: boolean;
	hideIcon?: boolean;
	forceShowLabel?: boolean;
}> = (props) => <GenericButton {...props} variant="add" icon={faPlus} />;

export default AddButton;
